module.exports = __webpack_public_path__ + "img/74.6f11155b.jpg";